<template>
  <div id="activities">
    <h1 class="mt-2">Activities</h1>

    <p>
      <span
        v-for="calendar in dashboard.data.modules.googleCalendar.calendars"
      >
        <span
          class="biathlon-cal dot"
          :style="'background-color: ' + calendar.color.hex + ';'"
        ></span> {{ calendar.title }}
      </span>
    </p>

    <div id="calendar"></div>

    <!-- Calendar Popup -->
    <div
      v-if="popup.active == true"
      class="calendar-popup"
    >
      <div class="calendar-popup-content">
        <div class="clickable calendar-popup-close"
          @click="popup.active = false"
        ><i class="fas fa-times"></i></div>
        <h2>{{ popup.title }}</h2>
        <p
          v-if="popup.allDay == false"
          class="lead"
        >Start: {{ popup.startTime | shortTime }}<br>End: {{ popup.endTime | shortTime }}</p>
        <p
          v-if="popup.allDay == true"
          class="lead"
        >All Day</p>
        <p
          v-if="popup.location.length > 1"
        ><strong>{{ popup.location }}</strong></p>
        <p
          v-if="popup.description.length > 1"
          v-html="popup.description"
        ></p>
      </div><!-- /.calendar-popup-content -->
    </div><!-- /.calendar-popup -->

  </div><!-- /#activities -->
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../firebaseConfig.js')

export default {
  data() {
    return {
      popup: {
        active: false,
        title: '',
        description: '',
        startTime: '',
        endTime: '',
        location: '',
        allDay: false,
        layers: {
          biathlon: true,
        }
      }
    }
  },
  mounted() {
    let self = this;
    setTimeout(function() {
      self.initCalendar()
    }, 500)
  },
  computed: {
    ...mapState([
      'dashboard'
    ])
  },
  methods: {
    initCalendar() {
      let self = this;

      var calendarEl = document.getElementById('calendar');

      let calendarSources = []
      for (let i = 0; i < self.dashboard.data.modules.googleCalendar.calendars.length; i++) {
        let thisCal = self.dashboard.data.modules.googleCalendar.calendars[i]
        calendarSources.push({
          googleCalendarId: thisCal.id,
          color: thisCal.color.hex
        })
      }

      var calendar = new FullCalendar.Calendar(calendarEl, {
        plugins: [ 'dayGrid', 'list', 'timeGrid', 'googleCalendar', 'bootstrap' ],
        themeSystem: 'bootstrap',
        header: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,weekList'
        },
        defaultView: 'weekList',
        views: {
          weekList: {
            type: 'list',
            duration: { days: 7 },
            buttonText: 'list'
          }
        },
        // aspectRatio: 2,
        eventLimit: true,
        displayEventTime: true,
        visibleRange: function(currentDate) {
          // Generate a new date for manipulating in the next step
          var startDate = new Date(currentDate.valueOf());
          var endDate = new Date(currentDate.valueOf());

          // Adjust the start & end dates, respectively
          startDate.setDate(startDate.getDate()); // One day in the past
          endDate.setDate(endDate.getDate() + 7); // Two days into the future

          return { start: startDate, end: endDate };
        },

        // API Key
        googleCalendarApiKey: this.dashboard.data.modules.googleCalendar.apiKey,
        // Calendar Sources
        eventSources: calendarSources,

        // OLD CRAFTSBURY
        // googleCalendarApiKey: 'AIzaSyC9zotTF9JuicbwrwmJxzRAHBswu-8CJ2I',
        // eventSources: [
        //   {
        //     id: 'biathlon',
        //     googleCalendarId: '8avaggergqplct2v5n3vrilrok@group.calendar.google.com',
        //     color: '#3f51b5'
        //   },
        //   {
        //     id: 'cycling',
        //     googleCalendarId: 'p8jradt8a21gvbfgbv9vkanjd8@group.calendar.google.com',
        //     color: '#009688'
        //   },
        //   {
        //     id: 'fitness',
        //     googleCalendarId:'t4q01dvskapil87d2slr5aosac@group.calendar.google.com',
        //     color: '#f4511e'
        //   },
        //   {
        //     id: 'running',
        //     googleCalendarId: 'qv2ag1qfgjal16cu4b631hrd14@group.calendar.google.com',
        //     color: '#8e24aa'
        //   },
        //   {
        //     id: 'sculling',
        //     googleCalendarId: '5u6crmicptec8lf2sthcsctjak@group.calendar.google.com',
        //     color: '#7cb342'
        //   },
        //   {
        //     id: 'skiing',
        //     googleCalendarId: 'ceaest5cku0ept2d5c9617r6hc@group.calendar.google.com',
        //     color: '#e4c441'
        //   },
        //   {
        //     id: 'community',
        //     googleCalendarId: 'ib1bc134vv09p8bpdfeg6otq9k@group.calendar.google.com',
        //     color: '#A79B8E'
        //   }
        // ],

        eventClick: function(arg) {
          arg.jsEvent.preventDefault();
          console.log(arg)
          console.log(self.popup)
          self.popup.title = arg.event.title
          self.popup.startTime = arg.event.start
          self.popup.endTime = arg.event.end
          self.popup.allDay = arg.event.allDay
          if (arg.event.extendedProps.location) {
            self.popup.location = arg.event.extendedProps.location
          } else {
            self.popup.location = ''
          }
          if (arg.event.extendedProps.description) {
            self.popup.description = arg.event.extendedProps.description
          } else {
            self.popup.description = ''
          }
          self.popup.active = true
        }

      });

      calendar.render();
    }
  },
  filters: {
    shortTime(time) {
      var a = new Date(time);

      // var start = new Date(this.popup.startTime)
      // var end = new Date(this.popup.startTime)
      // if (start.getDate() == end.getDate() && start.getMonth() == end.getMonth() && start.getFullYear() == end.getFullYear()) {
      //   return d.getDate() + '/' + (d.getMonth()+1) + '/' + d.getFullYear() + ' - ' + d.get;
      // }

      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var year = a.getFullYear();
      var month = months[a.getMonth()];
      var date = a.getDate();
      var timeString = a.toLocaleTimeString("en-US");
      var time = month + ', ' + date + ', ' + year + ' - ' + timeString;
      return time;
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Activities.vue